import React from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import SidebarMenu from '../../components/SidebarMenu';
import SectionHeading from '../../components/SectionHeading';
import BannerSection from '../../components/BannerSection';
import BreadcrumbNav from '../../components/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Instituição' },
    { label: 'Missão Visão e Valores' }
];

function Missao_visao_valor() {
    return (
      <div>
      <header id='header'>
        <AppHeader />
      </header>
      <BannerSection
          title="Nossa Essência Institucional"
          subtitle="A Missão, Visão e Valores do Instituto Superior Politécnico Atlântida"
          description={`No Instituto Superior Politécnico Atlântida, nossa missão é preparar profissionais com conhecimento científico, técnico e cultural, comprometidos com a inovação e o desenvolvimento sustentável da sociedade.`}
          backgroundImage={require('../../assets/BannerANU_ispa.jpg')} 
          backgroundId="instituition-Banner"
          />
      <BreadcrumbNav items={caminho} />
      <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
        <br />
        <div className="row flex-row-reverse">
          <div className="col-12 col-md-4 col-lg-3 col-xl-2">
              <SidebarMenu
                  title="Instituição"
                  items={[
                  { label: "Apresentação", href: "/instituicao" },
                  { label: "Palavras do Presidente", href: "/instituicao/palavra-do-presidente" },
                  { label: "Organigrama", href: "/instituicao/organigrama" },
                  { label: "Legalidade", href: "/instituicao/legalidade" },
                  { label: "Missão, Visão e Valores", href: "/instituicao/missao-visao-valores" },
                  { label: "Apoio Social", href: "/instituicao/apoio-social" },
                  { label: "Perguntas Frequentes", href: "/instituicao/perguntas-frequentes" },
                  { label: "Decretos", href: "/instituicao/decretos" },
                  { label: "Regulamento", href: "/instituicao/regulamentos" },
                  ]}
              />
              </div>
        <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
          <br />
          <div className="details-magazine">
            <SectionHeading title="Missão visão e valor" />
          <div className="title-holder-modern text-left py-4 px-3 px-md-4">
            <h2 className="section-title text-success">Missão</h2>
            <p className="section-subtitle">
            O Instituto Superior Politécnica Atlântida (ISP-Atlântida) tem como missão:
            <br />
            Preparar quadros com conhecimento científico, técnico e cultural em ramos ou especialidades correspondentes
            a áreas diferenciadas do saber.
            </p>
          </div>

          <div className="title-holder-modern text-left py-4 px-3 px-md-4">
            <h2 className="section-title text-success">Visão</h2>
            <p className="section-subtitle">
            Construir e difundir o conhecimento, comprometido com a formação de pessoas capazes de inovar e contribuir para o desenvolvimento da sociedade, de modo sustentável.
            </p>
          </div>

          <div className="title-holder-modern text-left py-4 px-3 px-md-4">
            <h2 className="section-title text-success">Valores</h2>
            <ul className="section-subtitle">
            <li><b style={{color:'#00761F'}}>Qualidade e Excelência:</b> Esforçar-se para os mais altos padrões, conforme comparado e avaliado pelos pares;</li>
            <li><b style={{color:'#00761F'}} >Responsabilidade:</b> Compromisso com o bom uso dos recursos humanos, fiscais e físicos que nos são confiados e atualizados;</li>
            <li><b style={{color:'#00761F'}}>Transparência:</b> Abertura ao escrutínio público sobre nossas ações, processos e uso de nossos recursos;</li>
            <li><b style={{color:'#00761F'}}>Diversidade:</b> Reconhecer que a diversidade e a excelência são mutuamente inclusivas, melhorando o nosso ensino, a erudição e o envolvimento da comunidade;</li>
            <li><b style={{color:'#00761F'}}>Integridade:</b> Consistentemente abraçando e praticando honestidade, verdade e liberdade em tudo o que fazemos;</li>
            <li><b style={{color:'#00761F'}}>Respeito:</b> Tratando todas as partes interessadas com civilidade e dignidade;</li>
            <li><b style={{color:'#00761F'}}>Responsabilidade Social e Envolvimento da Comunidade:</b> Contribuindo para o bem-estar intelectual, social e econômico das comunidades que servimos;</li>
            <li><b style={{color:'#00761F'}}>Rigor:</b> Rigidez na organização, planificação e acompanhamento dos trabalhos prestados.</li>
            </ul>
          </div>
          <br />
          </div>
        </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
      </main>

      <AppLayout />
      </div>
    );
}

export default Missao_visao_valor;